// 保单状态
export const PolicyStatus = {
  selfAccSucess: '个账划扣成功',
  wait_activate: '待激活',
  examine_pass: '核验通过',
  examine_fail: '核验未通过',
  generating: '生成中',
  generate_fail: '出单中',
  unEffective: '已失效',
  surrender: '已退保',
  effective: '已生效',
  cancelOrder: '已撤单',
  other: '其他',
  theEnd: '已终止',
  theClose: '已关闭',
  partEffective: '部分生效'
}

// 保单支付状态
export const PolicyPayStatus = {
  selfAccSucess: '个账划扣成功',
  waitPay: '待支付',
  paying: '支付中',
  yetPay: '已支付',
  payYet: '已支付',
  payFail: '支付失败',
  refunding: '退款中',
  refund: '已退款',
  partRefund: '部分退款',
  abrogate: '已取消',
  payClose: '支付关闭'
}

// 性别
export const Gender = {
  '0': '男',
  '1': '女',
  '3': '未知'
}

// 关系
export const Relation = {
  oneself: '本人',
  parent: '父母',
  spouse: '配偶',
  children: '子女'
}

// 公司
export const Company = {
  ONE_AN: '易安财产保险',
  QH_INS: '前海财险保险',
  HUA_GUI: '华贵大麦保险',
  TAI_KANG: '泰康保险',
  FO_SUN: '复星人寿保险',
  HONG_KANG: '弘康人寿保险',
  GUO_RUI: '国华华瑞保险'
}
// 证件类型
export const CertifyType = {
  identityCard: '身份证',
  passport: '护照',
  officerCard: '军官证',
  familyRegister: '户口本',
  birthCertificate: '出生证',
  policeCertificate: '警官证',
  HongKongMacaoAndTaiwanPass: '港澳台通行证',
  TAX_REGISTRATION_CERTIFICATE: '统一社会信用代码',
  otherIdentityCard: '外国人永久居住身份证',
  TaiWanPass: '台湾居民居住证',
  HongKongMacaoPass: '港澳居民居住证'
}

// 保单相关人
export const PolicyPerson = {
  policyHolder: '投保人',
  beneficiary: '受益人',
  insured: '被保险人'
}
// 支付方式
export const ClientPayType = {
  APP: 'APP支付',
  WEB: 'H5支',
  JSAPI: '公众号内支付'
}
// 支付类型
export const PayAccountTypeStatus = {
  alipayAcc: '支付宝',
  weichatAcc: '微信支付',
  unionPayDirect: '云闪付',
  icbcEPay: '工行e支付',
  selfAcc: '个账划扣'
}
export const baoxian = {
  // SY21001:'KUN_PENG', // 鲲鹏保险经纪
  YUEYANG2021001:'CHINA_LIFE', // 中国人寿
  // SY21001_TP02: 'TAIPING_PROPERTY', // 太平财险
  // SY21001_TK01: 'TAI_KANG_PENSION', // 泰康养老
  // SY21001_PICC01: 'PICC_PENSION',  // 人保财险
  // SY21001_PICC02: 'PICC_HEALTH', // 人保健康
  // SY21001_PA01: 'PING_AN_PENSION', // 平安养老
  // SY21001_PA02: 'PING_AN_PROPERTY', // 平安财险
  // SY21001_TB01: 'CPIC', // 太保财险
  // SY21001_YT01: 'API', // 亚太财险
  // SY21001_RS01: 'RONG_SHENG' // 融盛财险
}

// 个账划扣类型
export const DeductionMethod = {
  familySolidarity: '家庭共济',
  individualAccountPayment: '个账划扣'
}


// 证件类型 columns
export const CertifyTypeColumns = [
  { type: 'identityCard', text: '身份证' },
  { type: 'familyRegister', text: '户口本' },
  { type: 'passport', text: '护照' },
  // { type: 'officerCard', text: '军官证' },
  { type: 'HongKongMacaoPass', text: '港澳居民居住证' },
  { type: 'TaiWanPass', text: '台湾居民居住证' },
  { type: 'otherIdentityCard', text: '外国人永久居住身份证' }
]